
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/box/questions/add",
      function () {
        return require("private-next-pages/box/questions/add.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/box/questions/add"])
      });
    }
  